export const RenderValueTypes = {
  CHIPS: 'CHIPS',
  COUNT: 'COUNT',
  COMMA_SEPARATED: 'COMMA_SEPARATED'
};
